import { useTrackImpressionEventByIntersection } from "@product/scmp-sdk";
import React, { useCallback } from "react";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { Event as Ga4Event } from "scmp-app/components/tracking/google-analytics-4/types";
import { pathname as newslettersPathname } from "scmp-app/pages/newsletters";

import Email from "./icon-email.svg";
import { Button, Container, Title } from "./styles";

export type Props = {
  className?: string;
  onClick: (destination: string) => void;
};

export const FooterNewsletter: React.FunctionComponent<Props> = ({ className, onClick }) => {
  const ga4ImpressionEvent = useCallback<() => Ga4Event>(
    () => ({
      action: "imp",
      category: "nl",
      customized_parameters: {
        internal_campaign: "",
        trigger_point: "footer inline",
      },
      subcategory: "sign_up",
    }),
    [],
  );
  const { captureTrackImpressionEventTargetElement } = useTrackImpressionEventByIntersection({
    ga4TrackingHandler: sendGA4Tracking,
    getGa4Event: ga4ImpressionEvent,
    options: { isSendGA4Tracking: true, shouldSendOnce: true },
  });
  return (
    <Container className={className} ref={captureTrackImpressionEventTargetElement}>
      <Title>Sign up for our newsletters</Title>
      <Button
        onClick={() => {
          sendGA4Tracking({
            action: "click",
            category: "nl",
            customized_parameters: {
              internal_campaign: "",
              trigger_point: "footer inline",
            },
            subcategory: "entry",
          });
          onClick(newslettersPathname);
        }}
        pathname={newslettersPathname}
      >
        <Email />
        <span>FIND OUT MORE</span>
      </Button>
    </Container>
  );
};

FooterNewsletter.displayName = "FooterNewsletter";
